import React, { Component } from 'react';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import get from 'lodash/get';
import Auth from 'shared/Auth';
import Select from 'react-select';
class SelectItem extends Component {
  state = {
    disabled: false,
    value: '',
    defaultOption: { value: this.props.response, label: this.props.response } || '',
    options: this.props.items || [],
    drowDownPlaceholder:
      get(Auth.getLanguage(), 'local_locale') === 'fr' ? 'Choisir' : 'Select an option',
  };

  onChange = option => {
    ('onChange');

    this.setState({
      value: get(option, 'value', ''),
      defaultOption: option,
    });

    const onChange = this.props.onChange;

    if (onChange) {
      onChange(get(option, 'value', ''));
    }
  };

  render() {
    const { defaultOption } = this.state;
    const Styles = {
      control: (styles, { data, isDisabled, isFocused, isSelected }) => {
        return {
          ...styles,
          backgroundColor: 'white',
          height: '2em',
          alignItems: 'center',
          borderColor: '#EA5F23',
          borderRadius: '1px',
          boxShadow: 'none',
          ':active': {
            ...styles[':active'],
            borderColor: isFocused ? '#f9711c' : '',
            boxShadow: 'none',
          },
          ':hover': {
            ...styles[':active'],
            borderColor: isFocused ? '#f9711c' : '',
            boxShadow: 'none',
          },
        };
      },
      option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        return {
          ...styles,
          borderColor: '#EA5F23',
          backgroundColor: isSelected ? '#EA5F23' : '',
          ':hover': {
            ...styles[':active'],
            backgroundColor: isFocused ? '#f9711c' : '',
          },
        };
      },
      input: styles => ({
        ...styles,
        height: '2em',
        alignItems: 'center',
        ':active': {
          ...styles[':active'],
          backgroundColor: 'red',
        },
      }),
      placeholder: styles => ({ ...styles }),
      singleValue: (styles, { data }) => ({ ...styles }),
    };
    return (
      <Select
        onChange={this.onChange}
        className="country-form-container"
        classNamePrefix="country-form"
        options={this.state.options}
        defaultValue={get(defaultOption, 'value') ? defaultOption : ''}
        isClearable
        styles={Styles}
        placeholder={`${this.state.drowDownPlaceholder}`}
      />
    );
  }
}

export default SelectItem;



// WEBPACK FOOTER //
// ./src/ui/Select.js